import { render } from "./App.vue?vue&type=template&id=27ef0531"
const script = {}

import exportComponent from "/home/streamer/htdocs/streamer.fun/resources/frontend/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__